<script>
export default {
  name: 'UlFormPassword',
  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    show: false,
  }),
  computed: {
    elInput() {
      return this.$refs.input.elInput;
    },
  },
};
</script>
<template>
  <div class="ul-form-password">
    <UlFormInput
      ref="input"
      :type="show ? 'text': 'password'"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
      @submit="$emit('submit', $event)"
    />
    <UlFormBtn
      v-if="!disabled"
      icon="el-icon-view"
      @click="show=!show"
    />
  </div>
</template>
<style lang="scss">
  .ul-form-password {
    display: flex;

    .ul-form-input {
      flex: 1;
    }

    .ul-form-btn {
      flex-shrink: 0;
    }
  }
</style>
